import React, { useState } from 'react';
import {
  deleteDidCountry,
  changeStatusCountry,
  externalPaymentList,
} from '../../api-services';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Dropdown } from 'react-bootstrap';
import swal from 'sweetalert';
import { openUserDetailsModal } from '../../redux/features/modalSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash,
  faEllipsisV,
  faEdit,
  faUserSlash,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import TableManager from '../../components/TableManager';
import { createTable } from '@tanstack/react-table';
import AddDidCountry from './AddDidCountry';
import Country from '../../components/Country';
// import AddFranceDID from './AddFranceDID';

const table = createTable();

const ExternalPaymentList = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [addDID, setAddDID] = useState(false);
  const [editData, setEditData] = useState({});

  const { mutateAsync: mutateAsyncdelete } = useMutation(
    'deleteDidCountry',
    deleteDidCountry,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('externalPaymentList');
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          // text: "Error",
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );
  const { mutateAsync: mutateAsyncUpdateStatus } = useMutation(
    'changeStatusCountry',
    changeStatusCountry,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('externalPaymentList');
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          // text: "Error",
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const handleDeleteNumber = (val) => {
    swal({
      text: 'Are you sure you want to delete this Country?',
      buttons: true,
      icon: 'warning',
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          let payload = {
            id: val?.id,
            type: 'external_payment',
          };
          await mutateAsyncdelete(payload);
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  const handleStatus = (val) => {
    switch (val) {
      case 'A':
        return 'Assigned';
      case 'P':
        return 'Pending';
      case 'U':
        return 'Used';
      default:
        return '---';
    }
  };

  const handleEditNumber = (val) => {
    setEditData(val);
    setAddDID(true);
  };

  const handleAddDID = () => {
    setAddDID(true);
  };

  const handleDeactivateBtn = async (data, uniquecode) => {
    let payload = {
      status: data,
      id: uniquecode,
      type: 'external_payment',
    };
    swal({
      text: 'Do You Want To Deactivate This Country?',
      icon: 'warning',
      buttons: true,
    }).then(async (willDeactive) => {
      if (willDeactive) {
        try {
          await mutateAsyncUpdateStatus(payload);
        } catch (error) {
          console.error(error);
        }
      }
    });
  };

  const handleActivateBtn = async (data, uniquecode) => {
    let payload = {
      status: data,
      id: uniquecode,
      type: 'external_payment',
    };
    swal({
      text: 'Do You Want To Activate This Country?',
      icon: 'warning',
      buttons: true,
    }).then(async (willActivate) => {
      if (willActivate) {
        try {
          await mutateAsyncUpdateStatus(payload);
        } catch (error) {
          console.error(error);
        }
      }
    });
  };

  const columns = [
    table.createDataColumn('created_at', {
      id: 'created_at',
      header: 'Date',
    }),

    table.createDataColumn('name', {
      id: 'name',
      header: 'Country',
      textAlign: 'left',
    }),

    table.createDataColumn('created_at', {
      id: 'Gateway',
      header: 'Accepted Gateway(s)',
      cell: () => `ZeyiPay | Google Pay`,
    }),
    table.createDataColumn('status', {
      id: 'status',
      header: 'Status',
      cell: (props) =>
        props.getValue() === 'A' ? (
          <a className="text-success" href="#">
            Activated
          </a>
        ) : (
          <a className="text-danger" href="#">
            Deactivated
          </a>
        ),
    }),
    table.createDisplayColumn({
      id: 'action',
      header: 'Action',
      cell: (props) => (
        <span>
          <Dropdown className="dropdown_dot mx-auto">
            <Dropdown.Toggle
              id="dropdown-basic"
              className="btn-light-blue btn-action "
            >
              <FontAwesomeIcon icon={faEllipsisV} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {props?.row?.original?.status === 'A' ? (
                <Dropdown.Item
                  href={void 0}
                  onClick={() =>
                    handleDeactivateBtn('D', props?.row?.original?.id)
                  }
                >
                  <FontAwesomeIcon icon={faUserSlash} />
                  Deactivate
                </Dropdown.Item>
              ) : (
                <Dropdown.Item
                  href={void 0}
                  onClick={() =>
                    handleActivateBtn('A', props?.row?.original?.id)
                  }
                >
                  <FontAwesomeIcon icon={faUser} />
                  Activate
                </Dropdown.Item>
              )}
              <Dropdown.Item
                href={void 0}
                onClick={() => handleDeleteNumber(props.row.original)}
              >
                <FontAwesomeIcon icon={faTrash} />
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </span>
      ),
    }),
  ];

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        // filter={filters}
        fetcherKey="externalPaymentList"
        fetcherFn={externalPaymentList}
        title="External Payment List"
        cta={true}
        ctaFunction={handleAddDID}
        ctaLabel="Add Country"
      />

      {addDID && (
        <AddDidCountry
          setOpenModal={setAddDID}
          openModal={addDID}
          editData={editData}
          setEditData={setEditData}
        />
      )}
    </>
  );
};

export default ExternalPaymentList;
